<template>
  <div>
    <v-col
      cols="12"
      class="px-0">
      <h4 class="field-header primary">
        Step 1 : กลุ่มเป้าหมาย
      </h4>
    </v-col>
    <v-col
      cols="12">
      <div class="text-h6 ml-13 text-decoration-underline">
        {{ filteredList.name }}
      </div>
      <v-checkbox
        v-model="reQueryCheck"
        class="ml-12"
        :readonly="!editable"
        label="Filter ใหม่ทุกครั้งที่ส่งโปรโมชั่น"
        @change="returnValue($event)" />
    </v-col>
  </div>
</template>

<script>
import FiltersProvider from '@/resources/FiltersProvider'

const filtersService = new FiltersProvider()
export default {
  props: {
    filterId: {
      type: String,
      default: ''
    },
    oldReQuery: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filteredList: {},
      reQueryCheck: true
    }
  },
  watch: {
    async filterId () {
      this.filteredList = await this.filtersInit()
    },
    oldReQuery (val) {
      this.reQueryCheck = val
    }
  },
  async mounted () {
    this.reQueryCheck = this.oldReQuery
    this.filteredList = await this.filtersInit()
  },
  methods: {
    async filtersInit () {
      let res = {}
      this.loading = true

      try {
        const { data } = await filtersService.getFilterByID(this.filterId)
        res = {
          id: data.id,
          name: data.name
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }

      return res
    },
    returnValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.target-field.v-input {
  width: 420px;
  font-weight: bold;
}

.field-header {
  text-align: center;
  padding: 8px;
  color: white;
  border-radius: 10px;
  width: 27%;
  font-size: 14px;
}
</style>
